export const wyrm_list_4 = [
  {
    type: 0,
    id: 400033,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400034,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400035,
    abilities: [ 
      { exclusive: '', effect: 'brk_pns', value: 25, maxValue: 30},
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400036,
    abilities: [ 
      { exclusive: '', effect: 'bg_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'wtr_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400037,
    abilities: [ 
      { exclusive: '', effect: 'brn_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'flm_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400038,
    abilities: [ 
      { exclusive: '', effect: 'stn_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'wnd_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400039,
    abilities: [ 
      { exclusive: '', effect: 'prl_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'lgh_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400040,
    abilities: [ 
      { exclusive: '', effect: 'ovd_pns', value: 10, maxValue: 15},
      { exclusive: '', effect: 'shd_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400041,
    abilities: [ 
      { exclusive: '', effect: 'crs_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'shs_prp', value: 10, maxValue: 10}
    ]
  }, {
    type: 0,
    id: 400042,
    abilities: [ 
      { exclusive: '', effect: 'psn_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'wtr_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400043,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'psn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400044,
    abilities: [ 
      { exclusive: '', effect: 'lst_dfn', value: 60, maxValue: 100},
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400045,
    abilities: [ 
      { exclusive: '', effect: 'crt_rt', value: 6, maxValue: 15},
      { exclusive: '', effect: 'brk_pns', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400046,
    abilities: [ 
      { exclusive: '', effect: 'lst_ofn', value: 40, maxValue: 60},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400047,
    abilities: [ 
      { exclusive: '', effect: 'hfl_dfn', value: 20, maxValue: 20},
      { exclusive: '', effect: 'psn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400048,
    abilities: [ 
      { exclusive: '', effect: 'hfl_skl_dmg', value: 35, maxValue: 40},
      { exclusive: '', effect: 'prl_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400049,
    abilities: [ 
      { exclusive: '', effect: 'str_dbb', value: 10, maxValue: 15},
      { exclusive: '', effect: 'stn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400050,
    abilities: [ 
      { exclusive: '', effect: 'flr_dvs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'lgh_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400051,
    abilities: [ 
      { exclusive: '', effect: 'stkr_str', value: 5, maxValue: 6},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400069,
    abilities: [ 
      { exclusive: '', effect: 'hfl_skl_dmg', value: 35, maxValue: 40},
      { exclusive: '', effect: 'skl_hst', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400055,
    abilities: [ 
      { exclusive: '', effect: 'md_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'wnd_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400056,
    abilities: [ 
      { exclusive: '', effect: 'mr_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'wtr_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400057,
    abilities: [ 
      { exclusive: '', effect: 'br_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'flm_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400058,
    abilities: [ 
      { exclusive: '', effect: 'jp_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'lgh_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400059,
    abilities: [ 
      { exclusive: '', effect: 'zd_rs', value: 20, maxValue: 25},
      { exclusive: '', effect: 'shd_rs', value: 5, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400053,
    abilities: [ 
      { exclusive: '', effect: 'brn_rs', value: 25, maxValue: 100},
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400060,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 40, maxValue: 50},
      { exclusive: '', effect: 'crt_dmg', value: 13, maxValue: 25}
    ]
  }, {
    type: 1,
    id: 400061,
    abilities: [ 
      { exclusive: '', effect: 'bln_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400100,
    abilities: [ 
      { exclusive: '', effect: 'slp_rs', value: 75, maxValue: 100}
    ]
  }, {
    type: 2,
    id: 400102,
    abilities: [ 
      { exclusive: '', effect: 'slp_rs', value: 25, maxValue: 100},
      { exclusive: '', effect: 'h70_str', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400105,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 40, maxValue: 50},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 0,
    id: 400112,
    abilities: [ 
      { exclusive: 'light', effect: 'crt_rt', value: 8, maxValue: 15},
      { exclusive: '', effect: 'shd_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400114,
    abilities: [ 
      { exclusive: '', effect: 'crs_rs', value: 25, maxValue: 100},
      { exclusive: '', effect: 'lst_rcv', value: 'Ⅲ', maxValue: 'Ⅳ'}
    ]
  }, {
    type: 1,
    id: 400116,
    abilities: [ 
      { exclusive: '', effect: 'stn_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'skl_dmg', value: 20, maxValue: 40}
    ]
  }, {
    type: 1,
    id: 400126,
    abilities: [ 
      { exclusive: '', effect: 'lst_ofn', value: 40, maxValue: 60},
      { exclusive: '', effect: 'crt_rt', value: 5, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400127,
    abilities: [ 
      { exclusive: '', effect: 'prl_rs', value: 25, maxValue: 100},
      { exclusive: 'shadow', effect: 'bf_tm', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400090,
    abilities: [ 
      { exclusive: '', effect: 'psn_rs', value: 50, maxValue: 100},
      { exclusive: '', effect: 'shd_rs', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400136,
    abilities: [ 
      { exclusive: '', effect: 'frc_stk', value: 40, maxValue: 50},
      { exclusive: '', effect: 'stk_hst', value: 10, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400138,
    abilities: [ 
      { exclusive: '', effect: 'bg_rs', value: 75, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400140,
    abilities: [ 
      { exclusive: '', effect: 'drg_dmg', value: 14, maxValue: 18}
    ]
  }, {
    type: 0,
    id: 400093,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 25, maxValue: 100},
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 2,
    id: 400152,
    abilities: [ 
      { exclusive: '', effect: 'psn_rs', value: 25, maxValue: 100},
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400119,
    abilities: [ 
      { exclusive: '', effect: 'str_dbb', value: 10, maxValue: 15},
      { exclusive: '', effect: 'h70_str', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400174,
    abilities: [ 
      { exclusive: '', effect: 'h70_dfn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'stn_rs', value: 25, maxValue: 100}
    ]
  }, {
    type: 3,
    id: 400293,
    abilities: [ 
      { exclusive: '', effect: 'shl_prp', value: 'Ⅲ', maxValue: 'Ⅲ'},
      { exclusive: '', effect: 'h70_dfn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400054,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'skl_hst', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400085,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 10, maxValue: 20},
      { exclusive: '', effect: 'brn_rs', value: 50, maxValue: 100}
    ]
  }, {
    type: 2,
    id: 400171,
    abilities: [ 
      { exclusive: '', effect: 'wnd_rs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'ovd_pns', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400282,
    abilities: [ 
      { exclusive: '', effect: 'enr_dbb', value: 'Ⅰ', maxValue: 'Ⅰ'},
      { exclusive: '', effect: 'bf_tm', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400335,
    abilities: [ 
      { exclusive: '', effect: 'hts_elu', value: 30, maxValue: 0},
      { exclusive: '', effect: 'skl_prp', value: 20, maxValue: 100}
    ]
  }, {
    type: 0,
    id: 400095,
    abilities: [ 
      { exclusive: 'flame', effect: 'flr_dvs', value: 12, maxValue: 15},
      { exclusive: '', effect: 'lst_rcv', value: 'Ⅲ', maxValue: 'Ⅳ'}
    ]
  }, {
    type: 0,
    id: 400336,
    abilities: [ 
      { exclusive: 'water', effect: 'skl_hst', value: 7, maxValue: 15},
      { exclusive: '', effect: 'bf_tm', value: 20, maxValue: 30}
    ]
  }, {
    type: 2,
    id: 400337,
    abilities: [ 
      { exclusive: '', effect: 'flm_rs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'ovd_pns', value: 5, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400339,
    abilities: [ 
      { exclusive: 'light', effect: 'skl_hst', value: 7, maxValue: 15},
      { exclusive: '', effect: 'str_dbb', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400379,
    abilities: [ 
      { exclusive: '', effect: 'drg_dmg', value: 10, maxValue: 18},
      { exclusive: 'wind', effect: 'crt_dmg', value: 15, maxValue: 25}
    ]
  }, {
    type: 0,
    id: 400381,
    abilities: [ 
      { exclusive: '', effect: 'h70_str', value: 10, maxValue: 20},
      { exclusive: '', effect: 'crt_rt', value: 5, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400387,
    abilities: [ 
      { exclusive: '', effect: 'lgh_rs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'rcv_ptn', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400385,
    abilities: [ 
      { exclusive: '', effect: 'hl_dbb', value: 'Ⅲ', maxValue: 'Ⅲ'},
      { exclusive: '', effect: 'str_dbb', value: 8, maxValue: 15}
    ]
  }, {
    type: 1,
    id: 400388,
    abilities: [ 
      { exclusive: '', effect: 'shd_rs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'hfl_crt_rt', value: 8, maxValue: 15}
    ]
  }, {
    type: 0,
    id: 400390,
    abilities: [ 
      { exclusive: '', effect: 'skl_prp', value: 25, maxValue: 100},
      { exclusive: '', effect: 'bf_tm', value: 20, maxValue: 30}
    ]
  }, {
    type: 0,
    id: 400392,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 15, maxValue: 25},
      { exclusive: '', effect: 'lst_rcv', value: 'Ⅲ', maxValue: 'Ⅳ'}
    ]
  }, {
    type: 0,
    id: 400396,
    abilities: [ 
      { exclusive: '', effect: 'frz_rs', value: 75, maxValue: 100}
    ]
  }, {
    type: 1,
    id: 400394,
    abilities: [ 
      { exclusive: '', effect: 'crt_dmg', value: 13, maxValue: 25},
      { exclusive: '', effect: 'flm_rs', value: 10, maxValue: 15}
    ]
  }, {
    type: 2,
    id: 400406,
    abilities: [ 
      { exclusive: '', effect: 'shd_rs', value: 10, maxValue: 15},
      { exclusive: 'light', effect: 'bf_tm', value: 25, maxValue: 30}
    ]
  }, {
    type: 1,
    id: 400408,
    abilities: [ 
      { exclusive: '', effect: 'flr_dvs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'h70_str', value: 8, maxValue: 20}
    ]
  }, {
    type: 0,
    id: 400410,
    abilities: [ 
      { exclusive: '', effect: 'psn_pns', value: 25, maxValue: 30}
    ]
  }, {
    type: 3,
    id: 400415,
    abilities: [ 
      { exclusive: '', effect: 'h70_dfn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'drg_dmg', value: 10, maxValue: 18}
    ]
  }, {
    type: 1,
    id: 400414,
    abilities: [ 
      { exclusive: '', effect: 'rcv_ptn', value: 10, maxValue: 20},
      { exclusive: '', effect: 'hl_dbb', value: 'Ⅲ', maxValue: 'Ⅲ'}
    ]
  }, {
    type: 0,
    id: 400286,
    abilities: [ 
      { exclusive: '', effect: 'flr_dvs', value: 10, maxValue: 15},
      { exclusive: '', effect: 'crt_dmg', value: 13, maxValue: 25}
    ]
  }
].reverse()